module.exports = __webpack_public_path__ + "s8.no2.00ec3b25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s8.no2.jpg
// module id = Tyb/
// module chunks = 0